export enum SyncStatusValue {
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    FAILED = 'failed',
}

export class SyncStatus {

    private static readonly VALID_VALUES: string[] = Object.values(SyncStatusValue);

    private readonly _value: SyncStatusValue;

    public constructor(value: string) {
        if (!SyncStatus.isValid(value)) {
            throw new Error(`Invalid SyncStatus value: ${value}`);
        }
        this._value = value as SyncStatusValue;
    }

    public static isValid(value: string): boolean {
        return SyncStatus.VALID_VALUES.includes(value);
    }

    public static inProgress(): SyncStatus {
        return new SyncStatus(SyncStatusValue.IN_PROGRESS);
    }

    public static completed(): SyncStatus {
        return new SyncStatus(SyncStatusValue.COMPLETED);
    }

    public static failed(): SyncStatus {
        return new SyncStatus(SyncStatusValue.FAILED);
    }

    public get value(): SyncStatusValue {
        return this._value;
    }

    public isInProgress(): boolean {
        return this._value === SyncStatusValue.IN_PROGRESS;
    }

    public isCompleted(): boolean {
        return this._value === SyncStatusValue.COMPLETED;
    }

    public isFailed(): boolean {
        return this._value === SyncStatusValue.FAILED;
    }

}
